RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const instagramChannelWall = Dashboard.curations.filters.ChannelFilterFactory({
        template: '#widgetInsightsInstagramAuthTemplate',
        upsellTemplate: '#widgetInstagramInsightsUpsellTemplate',
        channel: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
    });

    curations._BaseInstagramInsightsCuration = curations._BaseInsightsCuration.extend({

        source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS,

        appTitle: RivalIQ.strings.instagram_insights_app_title,

        beforeFilters: [
            curations.filters.instagramPresenceLoader,
            instagramChannelWall,
            curations.filters.noInstagramInsightsPresences,
            curations.filters.checkAccountAccessInstagram(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, '#widgetInsightsInstagramAuthTemplate'),
            curations.filters.insightsLoading(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, '/insights/instagram'),
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        formatPresence: function (currentPresence) {
            const me = this;

            if (currentPresence) {
                const handle = _.get(currentPresence.get('sources'), [me.source, 'handle']);
                if (handle) {
                    return `@${handle}`;
                }
            }
        },

        getTitleSlide: function () {
            const me = this;

            const companyId = me.getProp('companyId');
            const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
            const handle = `@${_.get(me.presence.get('sources'), [me.source, 'handle'])}`;
            const landscapeName = RivalIQ.state.view.get('landscapeName');

            return new RivalIQ.apps.Reports.models.Slide({
                style: RivalIQ.apps.Reports.models.Slide.styleTypes.INTRO,
                elements: {
                    head: me.getPptTitle(),
                    date: me.getExportTitleBarTimePeriod(),
                    brand: RivalIQ.apps.Reports.models.Slide.brandImages.getLarge(),
                    focusCompanyTitle: 'Company',
                    focusCompany: companyName,
                    activeTagTitle: 'Handle', // reusing the intro slide layout with different data, hence the key name mismatch.
                    activeTag: handle,
                    landscapeTitle: 'Landscape',
                    landscape: _.unescape(landscapeName)
                }
            });
        },

        getSwitchableItems: function () {
            const me = this;

            if (me.presences) {

                return _(me.presences.models)
                    .sortBy(function (presence) {
                        return _.get(presence.get('sources'), [me.source, 'handle']);
                    })
                    .map(function (presence) {
                        const tableWidget = (me.getProp('objectType') === RivalIQ.enums.insightsObjectType.post) ? me.getWidget('posts-table') : me.getWidget('stories-table');
                        const instanceId = me.getProp('instanceId');
                        return {
                            value: presence.get('companyId'),
                            display: me.formatPresence(presence),
                            action: function () {
                                const companyId = presence.get('companyId');
                                const path = me.getPath({
                                    companyId: companyId,
                                    presenceId: undefined,
                                    searchTerm: '',
                                    // only tack this on if we're switching in the details view of the table widget
                                    tableLayout: (instanceId && tableWidget && (instanceId === tableWidget.getProp('instanceId'))) ? tableWidget.getProp('layout') : null
                                });

                                me.saveLastSelectedInsightsPresence(companyId);
                                RivalIQ.execute('history:navigate', path, {
                                    trigger: true
                                });
                            }
                        };
                    })
                    .value();
            }
        }
    });
});
